const UserRow = ({ user }) => {
  const firstName = user?.first_name_fa ?? "-";
  const lastName = user?.last_name_fa ?? "-";
  const userFullName = firstName === "-" && lastName === "-" ? "-" : `${firstName} ${lastName}`.trim();

  return (
    <tr className="border-b border-neutral-200 transition-colors hover:bg-neutral-30">
      <td className="px-3 py-2 text-center text-neutral-700">{userFullName}</td>
      <td className="px-3 py-2 text-center text-neutral-700">{user?.mobile ?? "-"}</td>
    </tr>
  );
};

export default UserRow;
